export default __webpack_public_path__ + "static/Terrestrial Assemblage_pressrelease-3c9eb7c93b200756afa069ae814f6566.pdf";